module.exports = __webpack_public_path__ + "img/Snippets-blue.b0b822a5.svg";